/**
 * LXGW WenKai
 * Font Weight: 400
 */
export default {
    fontFamily: 'LXGW WenKai',
    fontWeight: 400,
    fontStyle: 'normal',
    unitsPerEm: 1000,
    metrics: {
        ascender: 928,
        descender: -256,
        lineGap: 0,
    },
    glyphs: {
        '%': 800,
        '&': 700,
        '@': 784,
        'B': 650,
        'D': 728,
        'F': 582,
        'H': 700,
        'J': 492,
        'K': 630,
        'L': 547,
        'M': 855,
        'P': 618,
        'R': 635,
        'S': 617,
        'V': 620,
        'W': 880,
        'b': 573,
        'f': 370,
        'j': 301,
        'm': 816,
        'p': 572,
        'q': 576,
        'r': 430,
        't': 360,
        'v': 490,
        'w': 730,
        'z': 490,
        '¢': 556,
        '£': 713,
        '§': 675,
        '©': 780,
        'ª': 320,
        '®': 780,
        '°': 320,
        'º': 320,
        'Æ': 900,
        'Ð': 728,
        'Þ': 618,
        'ß': 610,
        'æ': 900,
        'ð': 622,
        'þ': 572,
        'Ď': 728,
        'Đ': 728,
        'đ': 583,
        'Ĥ': 700,
        'Ħ': 700,
        'Ĳ': 492,
        'Ĵ': 492,
        'ĵ': 301,
        'Ķ': 630,
        'ĸ': 445,
        'Ĺ': 547,
        'Ļ': 547,
        'Ľ': 547,
        'ľ': 302,
        'Ŀ': 547,
        'ŀ': 300,
        'Ł': 547,
        'Œ': 945,
        'œ': 948,
        'Ŕ': 635,
        'ŕ': 430,
        'Ŗ': 635,
        'ŗ': 430,
        'Ř': 635,
        'ř': 430,
        'Ś': 617,
        'Ŝ': 617,
        'Ş': 617,
        'Š': 617,
        'ţ': 360,
        'ť': 360,
        'ŧ': 360,
        'Ŵ': 880,
        'ŵ': 730,
        'ź': 490,
        'ż': 490,
        'ž': 490,
        'ſ': 370,
        'ƀ': 573,
        'Ɓ': 677,
        'Ƃ': 629,
        'ƃ': 573,
        'Ƅ': 604,
        'ƅ': 523,
        'Ɔ': 725,
        'Ɖ': 728,
        'Ɗ': 766,
        'Ƌ': 629,
        'ƍ': 556,
        'Ɛ': 627,
        'Ƒ': 582,
        'Ɣ': 620,
        'ƕ': 883,
        'Ɩ': 314,
        'Ƙ': 669,
        'ƛ': 534,
        'Ɯ': 816,
        'Ƣ': 869,
        'ƣ': 683,
        'ƥ': 572,
        'Ʀ': 635,
        'Ƨ': 617,
        'Ʃ': 557,
        'ƪ': 430,
        'ƫ': 360,
        'ƭ': 360,
        'Ʊ': 762,
        'ƶ': 490,
        'Ʒ': 552,
        'Ƹ': 552,
        'ƹ': 540,
        'ƺ': 491,
        'ƽ': 512,
        'ƾ': 540,
        'ƿ': 572,
        'ǀ': 351,
        'ǁ': 351,
        'Ǆ': 1310,
        'ǅ': 1200,
        'ǆ': 1037,
        'Ǉ': 983,
        'ǈ': 776,
        'ǉ': 541,
        'Ǌ': 1203,
        'ǋ': 1004,
        'ǌ': 855,
        'Ǣ': 900,
        'ǣ': 900,
        'Ǩ': 630,
        'ǩ': 542,
        'Ǯ': 552,
        'ǯ': 540,
        'ǰ': 301,
        'Ǳ': 1310,
        'ǲ': 1200,
        'ǳ': 1037,
        'Ƕ': 1004,
        'Ƿ': 556,
        'Ǽ': 900,
        'ǽ': 900,
        'Ȑ': 635,
        'ȑ': 430,
        'Ȓ': 635,
        'ȓ': 430,
        'Ș': 617,
        'ț': 360,
        'ȝ': 456,
        'Ȟ': 700,
        'Ƞ': 675,
        'ȡ': 625,
        'Ȣ': 627,
        'ȣ': 586,
        'ȥ': 490,
        'ȴ': 318,
        'ȵ': 637,
        'ȶ': 360,
        'ȷ': 301,
        'ȸ': 880,
        'ȹ': 880,
        'Ƚ': 547,
        'ɀ': 490,
        'Ɂ': 570,
        'ɂ': 511,
        'Ƀ': 650,
        'Ʌ': 620,
        'Ɉ': 492,
        'ɉ': 301,
        'Ɋ': 788,
        'ɋ': 576,
        'Ɍ': 635,
        'ɍ': 430,
        'Ͱ': 568,
        'ͱ': 464,
        'Ͳ': 617,
        'ʹ': 200,
        '͵': 200,
        'ͷ': 583,
        'Ϳ': 492,
        '΄': 286,
        '΅': 424,
        'Έ': 727,
        'Ή': 790,
        'Ί': 383,
        'Ό': 811,
        'Ύ': 759,
        'Ώ': 821,
        'ΐ': 294,
        'Β': 636,
        'Γ': 573,
        'Δ': 650,
        'Η': 701,
        'Κ': 630,
        'Μ': 855,
        'Ξ': 599,
        'Π': 627,
        'Ρ': 618,
        'Σ': 557,
        'Φ': 737,
        'Ψ': 754,
        'Ω': 755,
        'ί': 294,
        'ΰ': 558,
        'β': 565,
        'γ': 480,
        'δ': 556,
        'ζ': 514,
        'θ': 570,
        'ι': 294,
        'κ': 501,
        'λ': 534,
        'ν': 515,
        'ξ': 528,
        'ο': 568,
        'ρ': 578,
        'ς': 516,
        'σ': 572,
        'τ': 446,
        'υ': 558,
        'φ': 621,
        'χ': 486,
        'ψ': 611,
        'ω': 687,
        'ϊ': 294,
        'ϋ': 558,
        'ό': 568,
        'ύ': 558,
        'ώ': 687,
        'Ϗ': 630,
        'ϒ': 644,
        'ϓ': 759,
        'ϔ': 644,
        'ϕ': 574,
        'ϖ': 668,
        'ϗ': 586,
        'ϛ': 516,
        'Ϝ': 573,
        'ϝ': 476,
        'Ϟ': 585,
        'ϟ': 560,
        'Ϡ': 625,
        'ϡ': 675,
        'ϰ': 586,
        'ϱ': 578,
        'ϳ': 301,
        'ϵ': 522,
        '϶': 522,
        'Ϸ': 618,
        'ϸ': 572,
        'Ϻ': 817,
        'ϻ': 639,
        'ϼ': 578,
        'Ͻ': 725,
        'Ͽ': 725,
        ' ': 333,
        ' ': 250,
        ' ': 167,
        ' ': 200,
        ' ': 100,
        '​': 0,
        '•': 392,
        '′': 286,
        '″': 388,
        '‴': 520,
        '‶': 388,
        '‷': 520,
        '⁂': 900,
        '⁄': 330,
        '⁒': 330,
        'ⁱ': 180,
        'ⁿ': 340,
        'ₐ': 320,
        'ₑ': 320,
        'ₒ': 320,
        'ₓ': 300,
        'ₔ': 330,
        'ₕ': 320,
        'ₖ': 305,
        'ₗ': 180,
        'ₘ': 457,
        'ₙ': 340,
        'ₚ': 320,
        'ₛ': 300,
        'ₜ': 300,
        '₠': 700,
        '₣': 582,
        '₤': 713,
        '₨': 1099,
        '₩': 880,
        '₪': 802,
        '€': 750,
        '₭': 630,
        '₯': 1069,
        '₱': 618,
        '₴': 617,
        '₶': 595,
        '₷': 637,
        '₹': 554,
        '₺': 649,
        '₻': 781,
        '₼': 754,
        '₽': 618,
        '₿': 650,
        'ℏ': 618,
        'ℓ': 557,
        '℞': 633,
        '℠': 810,
        '™': 790,
        '℩': 294,
        'Ⅎ': 596,
        '⅂': 547,
        '⅃': 596,
        'ⅎ': 476,
        '∂': 630,
        '∏': 627,
        '∑': 557,
        '√': 640,
        '∛': 640,
        '∜': 640,
        '⍳': 294,
        '⍴': 578,
        '⍵': 687,
        '⍸': 294,
        '⍹': 687,
        '⏨': 635,
        '❛': 371,
        '❜': 371,
        '❝': 648,
        '❞': 648,
        '❟': 371,
        '❠': 648,
        '〪': 0,
        '〫': 0,
        '〬': 0,
        '〭': 0,
        '゙': 0,
        '゚': 0,
    },
    glyphsByWidth: {
        263: 'ilìíîïĩīĭįıĺļƚǐȉȋ',
        304: 'IÌÍÎÏĨĪĬĮİłƗǏȈȊΙΪ',
        350: ' !"\'(),-./:;[\\]{|} ¡¦·ĳǃͺ;· ‘’‚‛“”„‟−∕∖⋅\t\n\r',
        380: '²³¹⁰⁴⁵⁶⁷⁸⁹⁺⁻⁼⁽⁾₀₁₂₃₄₅₆₇₈₉₊₋₌₍₎',
        500: '*_`xy¨¯´¸ýÿŷƒƴȳɏ  ‒‵‾⁑∁∊∍⌃❲❳〿｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟﾠﾡﾢﾣﾤﾥﾦﾧﾨﾩﾪﾫﾬﾭﾮﾯﾰﾱﾲﾳﾴﾵﾶﾷﾸﾹﾺﾻﾼﾽﾾￂￃￄￅￆￇￊￋￌￍￎￏￒￓￔￕￖￗￚￛￜ￨￩￪￫￬￭￮',
        510: 'ksķśŝşšƙƨșȿέε',
        530: 'c¤«»çćĉċčƈȼͻͼͽϐϑϲ‹›⃀⍷',
        543: 'eèéêëēĕėęěǝȅȇȩɇήη',
        562: 'oòóôõöøōŏőơǒǫǭǿȍȏȫȭȯȱμϙ',
        575: 'adàáâãäåāăąďƌǎǟǡǻȁȃȧ₫',
        577: 'TŢŤŦƬƮȚȾͳΤπ₮₸',
        580: 'gĝğġģǥǧǵάαℊ⍶⍺',
        588: 'hnñĥħńņňŉŋƞǹȟℎ',
        590: 'u¬µùúûüũūŭůűųưǔǖǘǚǜȕȗ',
        600: '#$+0123456789<=>?XYZ^~¥±¿×Ý÷ŶŸŹŻŽƳƵƻƼǂȜȤȲɎΖΥΧΫ ‽₰⅄↊↋ㆴㆵㆶㆷㆻ',
        638: 'E¶ÈÉÊËĒĔĖĘĚƎƤȄȆȨɆΕ',
        690: 'AÀÁÂÃÄÅĀĂĄǍǞǠǺȀȂȦȺΆΑΛ₳',
        703: 'CÇĆĈĊČƇƏȻϚϹϾ₡₢₵₾',
        710: 'UÙÚÛÜŨŪŬŮŰŲƯƲǓǕǗǙǛȔȖɄ',
        738: 'NÑŃŅŇŊƝǸͶΝ₦',
        745: 'OQÒÓÔÕÖØŌŎŐƟƠǑǪǬǾȌȎȪȬȮȰΘΟϘϴΩ℧',
        752: 'GĜĞĠĢƓǤǦǴ₲⅁',
    },
    defaultWidth: 1000,
};
